import React, { useState, useContext } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import FormHelperText from '@mui/material/FormHelperText'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import TextField from '@mui/material/TextField'
import StepOne from './StepOne'
import { useNotifications } from '@toolpad/core/useNotifications'
import Typography from '@mui/material/Typography'
import axios from '../services/axiosInstance'
import Grid from '@mui/material/Grid'
import { useParams } from 'react-router'
import { CaptchaTokenContext } from '../context/CaptchaContext'
import Container from '@mui/material/Container'

const ApplicationForm = ({ selectedZone, selectedPost, onSubmitApplication }) => {
  const notifications = useNotifications()
  const [company, setCompany] = useState('')
  const [circle, setCircle] = useState('')
  const [circleList, setCircleList] = useState([])
  const [division, setDivision] = useState('')
  const [divisionList, setDivisionList] = useState([])
  const [name, setName] = useState('')
  const [activeStep, setActiveStep] = useState(0)
  const [stepOneDetails, setStepOneDetails] = useState({})
  const [loading, setLoading] = useState(false)
  const { zone, designation } = useParams()
  const selectedZoneName = zone ? zone.charAt(0).toUpperCase() + zone.slice(1) : ''

  const { setIsFormCompleted } = useContext(CaptchaTokenContext)

  const locationData = JSON.parse(window.localStorage.getItem('locationData'))
  const companies = locationData.zones.find((individualZone) => individualZone.name === selectedZoneName)?.companies || []
  console.log(locationData)
  console.log('Companies List:', companies)

  const handleCompanyChange = (event) => {
    setCompany(event.target.value)
    const circles = companies.find((company) => company.name === event.target.value)?.circles || []
    setCircle('')
    setCircleList(circles)
    setDivision('')
    setDivisionList([])
  }

  const handleCircleChange = (event) => {
    setCircle(event.target.value)
    const divisions = circleList.find((circle) => circle.name === event.target.value)?.divisions || []
    setDivisionList(divisions)
    setDivision('')
  }

  const handleDivisionChange = (event) => {
    setDivision(event.target.value)
  }

  const handleDropdownsReset = () => {
    setCompany('')
    setCircle('')
    setDivision('')
    setCircleList([])
    setDivisionList([])
    setActiveStep(0)
  }

  const handleSubmit = async () => {
    try {
      setLoading(true)
      const { phone, pin, new2024BatchMembers } = stepOneDetails
      const requestBody = {
        name: stepOneDetails.name || name,
        phoneNumber: `+91${phone}`,
        ...(new2024BatchMembers ? { isPinNotAssigned: true } : { pin }),
        userCompanyName: company,
        userCircleName: circle,
        userDivisionName: division,
        postZoneName: selectedZoneName,
        postDesignation: designation
      }
      await axios.post('/application/submit', requestBody)
      notifications.show('Thank you for applying! We will contact you soon.', {
        severity: 'success',
        autoHideDuration: 5000
      })
      handleDropdownsReset()
      setIsFormCompleted(true)
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error('API Error:', error.response.data)
        window.alert(error.response.data.message || 'Something went wrong')
      } else if (error.request) {
        // Request was made but no response received
        console.error('No response:', error.request)
        window.alert('No response from server. Please try again.')
      } else {
        // Other errors (like setting up the request)
        console.error('Error:', error.message)
        window.alert('Error: ' + error.message)
      }
      notifications.show('Error occurred while submitting application', {
        severity: 'error',
        autoHideDuration: 3000
      })
    } finally {
      setLoading(false)
    }
  }

  const handleStepOneSubmit = (details) => {
    setStepOneDetails(details)
    setActiveStep(1)
  }

  const steps = [
    'PIN and Mobile Number',
    'Place of Working'
  ]
  // const circles = companies.find((company) => company.name === company)?.circles || []
  // const divisions = circles.find((circle) => circle.name === circle)?.divisions || []
  return (
    <Box sx={{ p: 1, display: 'flex', flex: 1, flexDirection: 'column', minHeight: '60vh' }}>
      <Box sx={{ mx: 3 }}>
        <Typography variant='med_28_500'>Application Form for {designation.toUpperCase()}</Typography>
        <Typography textTransform='capitalize'>{selectedZoneName} Zone
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
        <Box sx={{ width: '100%', mt: 3, mb: 4 }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {activeStep === 0
          ? <StepOne onCompleteStepOne={handleStepOneSubmit} />
          : activeStep === 1 && (
            <Container>
              <Box sx={{ }}>
                {stepOneDetails.name
                  ? (
                    <Box
                      display='flex'
                      alignItems='center'
                      justifyContent='center'
                      sx={{
                        p: 2,
                        border: '1px solid',
                        borderRadius: '4px',
                        borderColor: 'secondary.main',
                        backgroundColor: 'secondary.light',
                        mb: 5
                      }}
                    >
                      <Typography
                        variant='semi_bold_14_600'
                        color='primary'
                      >
                        👋 Hello, {stepOneDetails.name}
                      </Typography>
                    </Box>
                    )
                  : <TextField
                      required
                      id='outlined-required'
                      label='Name'
                      placeholder='Please enter your name'
                      fullWidth
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />}
                <Typography variant='subtitle2' sx={{ mt: 3, mb: 0, textTransform: 'uppercase', fontWeight: 'bold' }} color='primary'>
                  Your place of working
                </Typography>
                <FormControl fullWidth sx={{ my: 2 }}>
                  <InputLabel id='demo-simple-select-label'>Select a Company</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={company}
                    label='Select a Company'
                    onChange={handleCompanyChange}
                  >
                    {companies.map((company) => (
                      <MenuItem key={company.name} value={company.name}>
                        {company.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id='demo-simple-select-label'>Select a Circle</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={circle}
                    placeholder='Select a Circle'
                    label='Select a Circle'
                    disabled={!company}
                    sx={{ opacity: company ? 1 : 0.5 }}
                    onChange={handleCircleChange}
                  >
                    {circleList.map((circle) => (
                      <MenuItem key={circle.name} value={circle.name}>
                        {circle.name}
                      </MenuItem>
                    ))}
                    {/* <MenuItem value={10}>Ten</MenuItem> */}
                  </Select>
                  {circleList.length === 0 && <FormHelperText>Please select a company to enable this field </FormHelperText>}
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id='demo-simple-select-label'>Select a Division</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={division}
                    label='Select a Division'
                    disabled={!circle}
                    sx={{ opacity: circle ? 1 : 0.5 }}
                    onChange={handleDivisionChange}
                  >
                    {divisionList.map((division) => (
                      <MenuItem key={division.name} value={division.name}>
                        {division.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {divisionList.length === 0 &&
                    <FormHelperText>Please select a circle to enable this field </FormHelperText>}
                </FormControl>
              </Box>
              <Grid
                container
         // spacing={2}
                direction='row-reverse'
                alignItems='flex-start'
                justifyContent='flex-start' sx={{ my: 3 }}
              >
                <Grid item size={{ xs: 12, sm: 1.06 }}>
                  <Button
                    fullWidth
                    disabled={loading}
                    onClick={handleSubmit}
                    variant='contained'
                  >Submit
                  </Button>
                </Grid>
              </Grid>
            </Container>
          )}
        {/* {activeStep === 1 &&
          <Grid
            container
         // spacing={2}
            direction='row-reverse'
            alignItems='flex-start'
            justifyContent='flex-start' sx={{ my: 3, mx: 2 }}
          >
            <Grid item size={{ xs: 12, sm: 1.06 }}>
              <Button
                fullWidth
                disabled={loading}
                onClick={handleSubmit}
                variant='contained'
              >Submit
              </Button>
            </Grid>
          </Grid>} */}
      </Box>
    </Box>
  )
}

export default ApplicationForm
